import { Loader2 } from "@/icons";

/**
 * Route-level loading fallback (used by React.Suspense for lazy pages).
 * Represents the app's loading-state strategy.
 */
export function PageLoader() {
  return (
    <div
      data-testid="page-loader"
      className="flex min-h-[60vh] w-full items-center justify-center"
    >
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
        <span className="text-sm text-muted-foreground">Loading…</span>
      </div>
    </div>
  );
}
